import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";

const DocumentPreviewWrapper = ({ children }: PropsWithChildren) => (
  <Box
    sx={[
      { py: 2, pl: 1, width: "100%", height: "100%" },
      (t) => ({ borderLeft: "1px solid", borderColor: t.palette.divider }),
    ]}
  >
    {children}
  </Box>
);

export default DocumentPreviewWrapper;
